import api from './Api'

const routeAuth = '/auth'
const routeview = '/users'
const paymentRoute = '/payments'
const stats = '/stats/users'

export default {
  getMe: params => api().get(`${routeview}/me`, { params: { ...params, expand: 'dealer' } }),
  get: params => api().get(`${routeview}`, { params: { ...params, expand: 'dealer' } }),
  getAdmins: params => api().get(`${routeview}/admins`, { params: { ...params, expand: 'dealer' } }),
  getOnlyUsers: params => api().get(`${routeview}`, { params: { ...params } }),
  getManager: params => api().get(`${routeview}/managers`, { params: { ...params, expand: 'dealer' } }),
  getDealerManager: (dealerId) => api().get(`/users/dealer-manager?dealer_id=${dealerId}`),
  getMyManager: params => api().get(`${routeview}/my-dealer-manager`),
  view: params => api().get(`${routeview}/${params.id}`),
  viewUser: params => api().get(`${routeview}/${params}`),
  viewUserDealer: params => api().get(`${routeview}/${params}`),
  postManager: (payload, params) => api().post(`${routeview}/create`, payload),
  post: (payload, params) => api().post(`${routeview}/add`, payload),
  put: (payload, params) => api().put(`${routeview}/${payload.id}`, payload),
  delete: payload => api().put(`${routeview}/${payload.id}`, payload),
  enable: payload => api().put(`${routeview}/${payload.id}`, payload),
  getClientSecret: params => api().get(`${paymentRoute}/session`, { params }),
  getBillingPortal: params => api().get(`${paymentRoute}/billing/portal`, { params }),
  requestResetPassword: payload => api().post(`${routeAuth}/request-password-reset`, payload),
  resetPassword: payload => api().post(`${routeAuth}/reset-password`, payload),
  getStats: params => api().get(`${stats}`, { params }),
  downloadManual: () => api().get(`${routeview}/download-manual`, { responseType: 'blob' }),
  setUserDealershipPermissions: payload => api().post('/user-dealership-permission/set-user-permissions', payload),
  getAvailablePermissions: () => api().get('/user-dealership-permission/get-available-permissions'),
  getUserDealershipPermissions: params => api().get('/user-dealership-permission/get-user-permissions', { params })
}
